import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { showAccessDeniedAlert } from "../../../utils/accessDenied"
import RoutesMap from "../../../route_control/RouteControl"
import axios from "axios"

export const upcomingEventList = createAsyncThunk('upcomingEventList', async ({ navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `event_data`,
            params: {
                'status': 'active',
                'event_activity': 'pending'
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('user_token'),
            }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const upcomingEventListSlice = createSlice({
    name: 'upcomingEventList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(upcomingEventList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                localStorage.clear()
                action.meta.arg.navigate(RoutesMap.LOGIN.path)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(upcomingEventList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default upcomingEventListSlice.reducer; 